// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/components/layout/Footer.css';

const Footer = () => {
    return (
        <footer>
            <ul>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/help">Help</Link></li>
                <li><Link to="/contact">Contact</Link></li>
                <li>
                    <a
                      href="https://www.instagram.com/viewfindershq/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src="/images/instagram_glyph_white.png"
                        alt="Instagram"
                        className="instagram-icon"
                      />
                    </a>
                </li>
            </ul>
            <p>&copy; {new Date().getFullYear()} ViewFinders</p>
        </footer>
    );
};

export default Footer;
